"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const arbitrum_1 = __importDefault(require("./arbitrum"));
const avalanche_1 = __importDefault(require("./avalanche"));
const localhost_1 = __importDefault(require("./localhost"));
const mainnet_1 = __importDefault(require("./mainnet"));
const optimism_1 = __importDefault(require("./optimism"));
const polygon_1 = __importDefault(require("./polygon"));
const test_1 = __importDefault(require("./test"));
exports.default = (chainID) => {
    if (chainID === types_1.ChainId.MAINNET) {
        return mainnet_1.default;
    }
    if (chainID === 1337) {
        return localhost_1.default;
    }
    if (chainID === types_1.ChainId.POLYGON) {
        return polygon_1.default;
    }
    if (chainID === types_1.ChainId.OPTIMISM) {
        return optimism_1.default;
    }
    if (chainID === types_1.ChainId.ARBITRUM) {
        return arbitrum_1.default;
    }
    if (chainID === types_1.ChainId.AVALANCHE) {
        return avalanche_1.default;
    }
    return test_1.default;
};
//# sourceMappingURL=index.js.map